import { render, staticRenderFns } from "./rule-modal.vue?vue&type=template&id=7dd4a20a&scoped=true&"
import script from "./rule-modal.vue?vue&type=script&lang=js&"
export * from "./rule-modal.vue?vue&type=script&lang=js&"
import style0 from "./rule-modal.vue?vue&type=style&index=0&id=7dd4a20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4a20a",
  null
  
)

export default component.exports